import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WaterBodiesResolve } from './water-bodies.resolve';
import { WaterBodiesComponent } from './water-bodies.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'manage/admin/water-bodies',
        component: WaterBodiesComponent,
        resolve: {
          waterBodies: WaterBodiesResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class WaterBodiesRoutingModule {}
